"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _styles = require("@ori-ui/mui-bundle/material/styles");
const styleOverrides = {
  rail: {
    height: 4,
    borderRadius: 2
  },
  track: {
    height: 4,
    borderRadius: 2
  },
  mark: {
    height: 4
  },
  thumb: ({
    theme
  }) => ({
    width: 28,
    height: 28,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[2],
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: theme.shadows[3],
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: theme.shadows[3]
    },
    [`&.${_material.sliderClasses.disabled}`]: {
      width: 28,
      height: 28,
      backgroundColor: 'currentColor',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }
  }),
  thumbColorPrimary: ({
    theme
  }) => ({
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: theme.shadows[3],
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: `${theme.shadows[3]}, 0px 0px 0px 8px ${(0, _styles.alpha)(theme.palette.primary.main, 0.17)}`
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: theme.shadows[4]
    }
  }),
  thumbColorSecondary: ({
    theme
  }) => ({
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: theme.shadows[3],
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: `${theme.shadows[3]}, 0px 0px 0px 8px ${(0, _styles.alpha)(theme.palette.secondary.main, 0.17)}`
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: theme.shadows[4]
    }
  })
};
const defaultProps = {
  color: 'primary'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiSlider.js.map